import React from 'react';
import { Link } from 'react-router-dom';
import { PROJECTS } from '../constants/projects';
import { ArrowRight, ExternalLink } from 'lucide-react';

const Projects: React.FC = () => {
  return (
    <div className="projects-page">
      <div className="breadcrumbs">
        <div className="shell breadcrumbs-inner">
          <h1>Our Projects</h1>
          <ul className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li className="active">Projects</li>
          </ul>
        </div>
      </div>

      <div className="shell" style={{ padding: '80px 0' }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="section-title">Portfolio of <span className="text-gradient">Innovation</span></h2>
          <p className="section-subtitle">A collection of our successful implementations across various industries.</p>
        </div>

        <div className="portfolio-grid">
          {PROJECTS.map((project, index) => (
            <article key={project.id} className="portfolio-item fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="portfolio-image" style={project.gradient ? { background: project.gradient, display: 'flex', alignItems: 'center', justifyContent: 'center' } : {}}>
                {project.image ? (
                  <img src={project.image} alt={project.title} style={{ width: '100%', height: '100%', objectFit: project.imageType || 'cover', padding: project.imageType === 'contain' ? '24px' : '0' }} />
                ) : (
                  <span style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>{project.id.toUpperCase().replace('-', ' ')}</span>
                )}
                {project.tag && (
                  <div style={{ position: 'absolute', top: '15px', right: '15px' }}>
                    <span className="badge-pill" style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(10px)', color: 'white', fontSize: '10px' }}>
                      {project.tag}
                    </span>
                  </div>
                )}
              </div>
              <div className="portfolio-content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <h3 style={{ margin: 0 }}>{project.title}</h3>
                  <span style={{ fontSize: '12px', background: 'var(--bg-elevated)', padding: '4px 8px', borderRadius: '4px', color: 'var(--accent)' }}>
                    {project.category}
                  </span>
                </div>
                <p>{project.description}</p>
                {project.link ? (
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-gradient" style={{ fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    View Project <ExternalLink size={14} />
                  </a>
                ) : (
                  <span className="text-link" style={{ color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    Case Study Coming Soon <ArrowRight size={14} />
                  </span>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
